import React from 'react';
import { about5, heroVideo, arashBg, aboutBg } from '../../assets/images';
import Header from '../../Components/Header/Header';
import WhyUs from '../../Components/home/WhyUs/WhyUs';
import Categories from '../../Components/home/Categories/Categories';
import Solutions from '../../Components/home/Solutions/Solutions';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';
import History from '../../Components/home/History/History';
import Awards from '../../Components/home/Awards/Awards';
import Profession from '../../Components/home/Profession/Profession';

const About = () => { 

    const { t, i18n } = useTranslation();

  return (
    <> 
        <Breadcrumb title={t("Haqqımızda")}/>

      <div className='bg-[#F9F9F9] font-secondFont'>
      <WhyUs/>
       <Profession/> 
      <History/> 
      <Awards/> 
      </div>
    </>
  );
};

export default About;
